import { Card, Text, View } from "@src/components";
import { formatDateTime } from "@src/utils/format-date";
import type { WasteSenseReportMeta } from "@visioni/a3s-reports/client-messages";

interface WasteSenseHeroProps {
  meta: WasteSenseReportMeta;
  /**
   * ISO instant the report row was last marked ready (the generator's
   * `generatedAt`). Reports regenerate daily, so this is the "last updated"
   * freshness signal. Optional/absent for a not-yet-ready row — the line is
   * omitted rather than shown blank in that case.
   */
  generatedAt?: string;
}

/**
 * Top-of-report header block. All copy comes pre-formatted from the
 * generator (`report_meta`) so the renderer never has to reconstruct
 * the title or window from raw bounds — the same strings appear in
 * the static PDF, the email digest, and this screen.
 */
export function WasteSenseHero({ meta, generatedAt }: WasteSenseHeroProps) {
  const generatedAtLabel = formatDateTime(generatedAt);
  return (
    <View gap="md" alignItems="flex-start">
      <Card bg="muted" px="md" py="xs" rounded={4} borderWidth={0}>
        <Text textStyle="xs/semibold" color="textMuted" letterSpacing={1} textTransform="uppercase">
          Operational status report
        </Text>
      </Card>
      <Text textStyle="h3" color="text">
        {meta.report_title}
      </Text>
      <Text textStyle="sm/regular" color="textMuted">
        {meta.report_subtitle}
      </Text>
      <Text textStyle="sm/regular" color="text">
        Reporting window: {meta.window_label}
      </Text>
      {generatedAtLabel ?
        <Text textStyle="sm/regular" color="textMuted">
          Generated At: {generatedAtLabel}
        </Text>
      : null}
    </View>
  );
}
